import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";

const images1 = "./Banner/megascale-brochure.png"

const AdminPage = ({ onLogout }) => {
   const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
  
    const toggleMenu = () => setIsOpen(!isOpen);
  
    React.useEffect(() => {
      setIsOpen(false);
    }, [location.pathname]);

  return (
    <>
      <div
        className={`fixed h-full w-64 top-0 bg-[#045fb5] text-white transform transition-transform duration-300 z-40 ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Close Button */}
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-4 text-white p-2 rounded-full"
          aria-label="Close Menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <Link to="home">
          <img
            src="/Megascale.png"
            alt="Megascale"
            className="w-32 h-auto pt-5 mx-auto"
          />
        </Link>
        <div className="flex justify-end items-center px-4">
        <button
          onClick={onLogout}
          className="mt-4 bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
        >
          Logout
        </button>
      </div>

        {/* Menu Links */}
        <ul className="flex flex-col gap-6 mt-10 ml-8">
          <li>
            <Link to="home" className="hover:text-yellow-400">
              Home
            </Link>
          </li>
          <li>
            <Link to="course" className="hover:text-yellow-400">
              Course
            </Link>
          </li>
          <li>
            <Link to="CourseList" className="hover:text-yellow-400">
              Course List
            </Link>
          </li>
        </ul>
        <div className="flex flex-col gap-6 mt-10">
          <div className="flex justify-center">
            <a
              href=''
              target="_blank"
              rel="noopener noreferrer"
              className=" inline-block"
            >
              <img
                src={images1}
                alt="Download Brochure"
                className="w-24 rounded-md"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Overlay for Sidebar */}
      {isOpen && (
        <div
          onClick={toggleMenu}
          className="fixed inset-0 bg-black bg-opacity-50 z-20"
        ></div>
      )}

      {/* Main Navigation Navbar (Visible on Medium and Larger Screens) */}
      <div className="hidden md:block fixed top-0 left-0 w-full z-30 bg-blue-600 shadow-lg">
     
        <nav className="flex justify-between items-center px-6 py-1  bg-[#045fb5]">
          <div className="flex-grow flex justify-start items-center">
            <Link to="home">
              <img
                src="/Megascale.png"
                alt="Megascale"
                className="w-32 h-auto p-1 mx-auto"
              />
            </Link>
          </div>
          <ul className="flex flex-row items-center text-lg text-white gap-6">
            <li>
              <Link to="home" className="hover:text-yellow-400">
                Home
              </Link>
            </li>
            <li>
              <Link to="course" className="hover:text-yellow-400">
                Course
              </Link>
            </li>
            <li>
            <Link to="CourseList" className="hover:text-yellow-400">
              Course List
            </Link>
          </li>
          </ul>
          <div className="flex justify-end items-center px-4">
        <button
          onClick={onLogout}
          className="mt-4 bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
        >
          Logout
        </button>
      </div>
        </nav>
      </div>

      {/* Mobile Navbar (Visible on Small Screens) */}
      <nav className="fixed top-0 left-0 z-30 bg-[#045fb5] py-2 shadow-lg w-full flex flex-colflex-col justify-between items-center md:hidden">
        <Link to="home">
          <img
            src="/Megascale.png"
            alt="Megascale"
            className="w-32 h-auto p-1 mx-auto"
          />
        </Link>

        {/* Centered Image (MegaScale) */}
        <div className="flex-grow flex justify-end items-center">

          {!isOpen && (
            <button
              onClick={toggleMenu}
              className="absolute top-3  text-white p-3"
              aria-label="Toggle Menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-8 h-8"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            </button>
          )}
        </div>
      </nav>
      <main>
      <Outlet />
    </main>
    </>
  );
};

export default AdminPage;
